import type { ExtractValues } from '../helpers';
import { Joi } from '../helpers';

const drinkFlows = ['disabled', 'self-service', 'staff-notify'] as const;

export const drinkFlowsSchema = Joi.string().valid(...drinkFlows);

export type DrinkFlows = ExtractValues<typeof drinkFlows>;

const drinksHandledBy = ['invitee', 'staff-member', 'administrator'] as const;

export const drinksHandledBySchema = Joi.string().valid(...drinksHandledBy);

export type DrinksHandledBy = ExtractValues<typeof drinksHandledBy>;
